import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "./PromptDialog";
import Constants from "../../../Action/Constants";
import Formatter from "../../../Localization/Formatter";
import { PageTransition } from "../Spinner/PageTransition";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Select from "../../Partials/Material/Select";
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { CoachNewCounterpartyDialog } from "../../Partials/Dialog/CoachNewCounterpartyDialog";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";

export class CoachPaymentCostsForAgency extends Component {
  protected timer;

  public defaultState = {
    isOpen: false,
    step: this.props.step ? this.props.step : 1,
    isSaving: false,
    renderChargeType: true,
    openCoachCreateNewCounterparty: false,
    considerUsedProcessDescription: this.trans("page/paymentupdate-preprocess/considerprocess-description"),
    typeIdForCostsCharge: TypeContainer.pickIdFromLabel("Other_payable"),
    counterpartyForCostsCharge: null,
    isSaveButtonClicked: false,
    activeStep: 0,
    skipped: new Set(),
    hasModifiedData: false,
    openLeavePrompt: false,
    errorFields: null,
    isClosePreprocessDialogOpen: false,
  };

  public state = {
    ...this.defaultState
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      counterpartyForCostsCharge: this.props.payment?.counterparty,
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen,
        step: nextProps.step ? nextProps.step : this.state.step
      });
    }
  }

  public clearState = () => {
    this.setState({
      ...this.defaultState
    })
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public onCloseCoach = () => {
    setTimeout(() => {this.clearState()}, 100);
    this.clearBackEndErrors();

    if (this.props.onCloseCoach) {
      this.props.onCloseCoach.call(this);
    }
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();
    if (activeStep === steps.length - 1) { // it is last step
      this.onCloseCoach();
          
      if (typeof this.props.initializePage === "function") {
        return this.props.initializePage.call(this, this.props.payment?.id)
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.plusOneStep();
      }
    }
  };

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("page/paymentupdate-preprocess/agencycosts-title", {agencyName: this.getAgency()?.name}), this.trans("coach/newtenant-step/second-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
      </div>
    )
  }

  // Steppers components content

  public firstStepDetails = () => {
    return (
      <div>
        <div>{this.trans("page/paymentupdate-preprocess/agencycosts-info", {agencyName: this.getAgency()?.name})}</div>
        
        <Select
          className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
          error={this.getErrorFor("typeIdForCharge")}
          variant="standard"
          value={this.state.typeIdForCostsCharge}
          onChange={this.changeTypeIdForCostsCharge}
          htmlFor="type"
          label={this.trans("section/charge-field/type-label")}
          input={
            <Input name="type" id="type"/>
          }
        >
          {
            TypeContainer.getChargeTypes(this.props.payment?.paymentClass?.label)
            .filter(chargeType => {
              if((TypeContainer.pickIdFromLabel("Savings_account_withdraw") === chargeType.id || TypeContainer.pickIdFromLabel("Savings_account_deposit") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_withdraw") && TypeContainer.pickIdFromLabel("Savings_account_deposit"))) {
                return false;
              }

              if((TypeContainer.pickIdFromLabel("Stub_receivable") === chargeType.id || TypeContainer.pickIdFromLabel("Stub_payable") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_receivable") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_payable"))) {
                return false;
              }

              if (!!this.state.typeIdForCostsCharge && chargeType.removed && (chargeType.id === this.state.typeIdForCostsCharge)) {
                return true;
              }

              if (chargeType.removed) {
                return false;
              }

              return true;
            })
            .map((type, index) => {
              return (
                <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
              );
            })
          }
        </Select>

        <div className="search-bar-container" style={{margin: "-20px 0"}}>
          <Searchbar
            {...this.props}
            id="selectedCounterpartyForCharge"
            className={"scroll-to-counterpartyId"}
            floatingLabelText={this.trans("label-paid-to")}
            allResults={true}
            objectField={true}
            onChange={this.selectCounterpartyForCostsCharge}
            onClear={this.clearCounterpartyForCostsCharge}
            selectedEntity={this.state.counterpartyForCostsCharge}
            searchParameter={"contactsSearch"}
            error={this.getErrorFor("counterpartyId")}
            showClickThroughLink={false}
            searchText={this.state.counterpartyForCostsCharge ? `${this.state.counterpartyForCostsCharge.nameOfEntity}, ${this.state.counterpartyForCostsCharge.displayName}` : null}
            styleInModal={"pick-object-modal"}
            createButton={"dropdown-button/newcounterparty"}
            openCoachCreateNewEntity={() => {
              this.setState({
                openCoachCreateNewCounterparty: true
              })}
            }
          />
        </div>

        {
          this.props.payment?.name && 
          <div className="hint-styles-wrapper" style={{marginTop: "10px"}}>
            <span className="hint-styles">{this.trans("page/paymentupdate-preprocess/agencycosts-hint", {paymentName: this.props.payment?.name})}</span>
          </div>
        }

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.selectCounterpartyForCostsCharge(entity)})
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        />
      </div>
    );         
  }

  public secondStepDetails = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("page/paymentupdate-postprocess/agencycosts-info")}
        </div> 
      </div>
    );
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.coachStartStepFirst();
  }

  public startStepSecond = () => {
    return this.coachStartStepSecond();
  }

  //Methods for step logic
  public coachStartStepFirst = () => {
    this.considerUsed(this.props.payment);
  }

  public coachStartStepSecond = () => {
    this.plusOneStep();
  }

  //Methods
  public considerUsed = (payment: PaymentInterface): void => {
    if (!payment) {
      return;
    }

    this.setState({
      considerUsedProcess: false
    });

    const payload: any = {
      payment: payment,
      type: this.state.typeIdForCostsCharge,
      description: this.state.considerUsedProcessDescription,
    }

    if (this.state.counterpartyForCostsCharge instanceof Person) {
      payload.contactId = this.state.counterpartyForCostsCharge?.id;
    }

    if (this.state.counterpartyForCostsCharge instanceof Company) {
      payload.companyId = this.state.counterpartyForCostsCharge?.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_COSTS_START,
        payload: {
          ...payload
        },
        onSuccess: () => {
          this.setState({
            activeStep: 1,
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public getChargeTypeBySelect = (id) => {
    const chargeType = this.props.globalTypes?.ChargeType;
    if(!!id) {
      for(const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  }

  public changeTypeIdForCostsCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);

      this.setState({
        typeIdForCostsCharge: type.id
      });
    }
  }

  public selectCounterpartyForCostsCharge = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      counterpartyForCostsCharge: entity,
    });
  }

  public clearCounterpartyForCostsCharge = (): void => {
    this.setState({
      counterpartyForCostsCharge: null,
    });
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
          {
            activeStep !== steps.length - 1 &&
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  isClosePreprocessDialogOpen: true
                })
              }}
              className="cancel-button"
            >
              {this.trans("dialog-button/close")}
            </Button>
          }

          <div>
            {
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
              >
              {activeStep === steps.length - 1 ? this.trans("button-close") : this.trans("button-finish")}
            </Button>
            }
          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-dialog has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.isOpen}
          onClose={this.onCloseCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div style={{width: "calc(100% - 65px)"}}>
            {this.trans("are-you-sure")
            }
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
              key="modal-cancel-btn"
              color="primary"
              onClick={this.closePreprocessDilaogOpen}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-no")}
              </Button>
            ),
            (
              <Button
              key="modal-add-btn"
              variant="contained"
              color="primary"
              onClick={this.onCloseCoach}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-yes")}
              </Button>
            )]
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}